<script>
import WidgetCard from '@widgets/widget-card.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    WidgetCard,
  },
  props: {
    showMoreBoxes: {
      type: Boolean,
      default: false,
    },
    playerId: {
      type: Number,
      default: () => null,
      required: true,
    },
    sheetClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stats: [],
      loaded: false,
      statsPerSheet: this.showMoreBoxes ? 20 : 16,
      statsModel: [],
      tooltips: {
        shots_on_target_perc: 'How many shots were successfull in Percent',
      },
    }
  },
  computed: {
    numSlides() {
      return this.stats.length === 0
        ? 0
        : Math.ceil(this.stats.length / this.statsPerSheet)
    },
    statsData() {
      const data = this.stats
      return data.map((stat) => ({
        key: stat.key,
        label: this.$t('stats.' + stat.key),
        value: this.formatStatValue(stat.key, stat.value),
        tooltip: this.getTooltipForKey(stat.key),
      }))
    },
  },
  async created() {
    this.getPlayerStatData({ id: this.playerId }).then((response) => {
      if (typeof response.player_actions_performance === 'undefined') {
        console.error("Couldn't load player Stat data", response)
      } else {
        const data = response.player_actions_performance
        // map as array
        this.stats = Object.keys(data).map((key) => ({
          key: key,
          value: data[key],
        }))

        this.$emit('loaded', this.loaded)
        this.loaded = true
      }
    })
  },
  methods: {
    ...mapActions('players', ['getPlayerStatData']),
    getTooltipForKey(key) {
      return typeof this.tooltips[key] !== 'undefined'
        ? this.tooltips[key]
        : false
    },
    formatStatValue(key, value) {
      if (key.indexOf('perc') >= 0) {
        return value + ' %'
      }
      return value
    },
    getStatsPerSlide(n) {
      n--
      return this.statsData.filter(
        (stat, i) =>
          i >= n * this.statsPerSheet && i < (n + 1) * this.statsPerSheet
      )
    },
  },
}
</script>

<template>
  <WidgetCard
    :title="$t('stats.title')"
    :sheet-class="[sheetClass, $style.content]"
  >
    <v-skeleton-loader v-if="!loaded" type="image" />
    <div :class="$style.stats">
      <v-carousel
        height="100%"
        show-arrows
        hide-delimiters
        tag="section"
        :continuous="false"
      >
        <v-carousel-item v-for="n in numSlides" :key="n" light>
          <div :class="showMoreBoxes ? $style.slidemore : $style.slide">
            <v-sheet
              v-for="(stat, i) in getStatsPerSlide(n)"
              :key="stat.label + i"
              :class="[$style.statBox]"
              tag="article"
            >
              <h6 :class="$style.label">{{ stat.label }}</h6>
              <p :class="['textAccent text-center', $style.value]">{{
                stat.value
              }}</p>
            </v-sheet>
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
  </WidgetCard>
</template>

<style lang="scss" module>
@import '@design';

.content {
  padding: 0 !important;
  background-color: transparent !important;
}

.article {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem 0 0;
}

.stats {
  display: flex;
  flex-direction: column;
  height: 100%;

  @media (min-width: $screen-xl) {
    flex-wrap: wrap;
  }
}

.slide {
  display: flex;
  display: grid;
  flex-wrap: wrap;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0.5rem;
  width: 100%;
  height: 100%;
}

.slidemore {
  grid-template-columns: repeat(5, 1fr);
  composes: slide;
}

.statBox {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.2rem 0.3rem 0.5rem 0.3rem;

  p {
    margin-bottom: 0;
    font-size: 1.2rem;
  }
}

.value {
  display: block;
  font-size: 0.67em;
}

.label {
  display: inline-block;
  padding: 0.2rem 0;
  font-weight: normal;
  word-break: break-word;
}

.btn {
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>
